<app-modal-basic #modalMessageBox id="msgBoxModal">
  <div class="app-modal-header modal-padding">
    <h6 class="modal-title">{{modalTitle}}</h6>
  </div>
  <div class="app-modal-body modal-padding" [innerHTML]="modalMessage">
  </div>
  <div class="app-modal-footer modal-padding">
    <button type="button" class="btn btn-primary btn-modal" (click)="onClickYes()" *ngIf="showYes">Yes</button>
    &nbsp;
    <button #noButtonModal type="button" class="btn btn-default btn-modal" (click)="onClickNo()">{{noButtonText}}</button>
    &nbsp;
    <button type="button" class="btn btn-default btn-modal" onclick="window.print()" *ngIf="showPrint">Print</button>
  </div>
</app-modal-basic>
